import mock from "../../../fake-db/mock.js"
const data = {
    slides:[
        {
            image: require('/public/images/fond/multi1.jpg'),
            title: 'Bienvenue dans MultiTRADE, votre logiciel de gestion commerciale.',
            description: 'Edité par Sunsoft, MultiTRADE remplit parfaitement son rôle en tant qu\'outil de travail pour vos activités commerciales.'
        },
        {
            image: require('/public/images/fond/multi2.jpg'),
            title: 'MultiTRADE c’est quoi ?',
            description: 'MultiTRADE est un logiciel de gestion complète. Il vous aide à mieux gérer le Stock, la Caisse et le Réapprovisionnement. Il gère bien les impayés Clients et Fournisseurs. Et il comporte des outils Statistiques avec graphes.'
        },
        {
            image: require('/public/images/fond/multi3.jpg'),
            title: 'Offrez de la motivation à votre Personnel',
            description: 'Simple et convivial, MultiTRADE facilitera en temps réel n’importe lequel de vos tâches ou activités.'
        },
        {
            image: require('/public/images/fond/multi4.jpg'),
            title: 'Ayez un contrôle total de vos Activités',
            description: 'Allant du stock à la vente, du fournisseur au client, gérez facilement vos transactions avec MultiTRADE.'
        }
    ],
}

mock.onGet("/api/acceuil/all").reply(() => {
    return [200, data.slides];
});